export enum NumericalDataType {
  Currency = 'monetary',
  Percentage = 'percentage',
  Units = 'counter',
  Ratio = 'ratio'
}
